import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=582aa0c8&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
import style0 from "./Player.vue?vue&type=style&index=0&id=582aa0c8&prod&lang=css"
import style1 from "./Player.vue?vue&type=style&index=1&id=582aa0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582aa0c8",
  null
  
)

export default component.exports